"use client";

import { VehicleSort } from "@alba-cars/common-modules";
import clsx from "clsx";

import { useVehicleFiltersData } from "../_hooks/useVehicleFilterData";
import { useFilterContext } from "./context/FilterContext";
import FilterDropdown from "@/components/ui/FilterDropdown";

interface SortDropdownProps {}

const isEqual = (a: VehicleSort | undefined, b: VehicleSort | undefined): boolean => {
  if (!a || !b) return a === b;

  // Check for year sort
  if ("year" in a && "year" in b) {
    return a.year === b.year;
  }

  // Check for finance.price sort
  if (a.finance?.price && b.finance?.price) {
    return a.finance.price === b.finance.price;
  }

  // Check for createdAt sort
  if (a.createdAt && b.createdAt) {
    return a.createdAt === b.createdAt;
  }

  // Check for mileage sort
  if (a.mileage && b.mileage) {
    return a.mileage === b.mileage;
  }

  return false;
};

export default function SortDropdown({}: SortDropdownProps) {
  const { queryOptions, updateQuery } = useFilterContext();
  const { sortOptions } = useVehicleFiltersData();

  const currentSort = sortOptions.find((option: any) => isEqual(option.value, queryOptions.options?.sort)) || null;

  const handleSelect = (option: { label: string; value: VehicleSort }) => {
    updateQuery({ options: { ...queryOptions.options, sort: option.value } });
  };
  const handleClear = () => {
    updateQuery({ options: { ...queryOptions.options, sort: undefined } });
  };

  return (
    <FilterDropdown
      id="sort-filter"
      options={sortOptions as any}
      isLoading={false}
      helperText="Sort By"
      onSelect={handleSelect}
      onClear={handleClear}
      value={currentSort as any}
      customClassNames={{
        control: (state) =>
          clsx(
            "inter flex-grow rounded-2xl border border-white bg-white px-3 py-3 font-semibold transition-all duration-300 hover:border hover:border-grey-border lg:min-w-[15rem] xl:min-w-[15rem]",
            state.isFocused ? "border-grey-border ring-1 ring-grey-border" : "",
            state.isDisabled && "opacity-50",
          ),
        placeholder: () => "!inter !text-primary-foreground text-medium",
      }}
    />
  );
}
